import { createContext } from 'react';
import type { BrandKit } from './types';

export const BrandKitContext = createContext<BrandKit>({});
